<script setup>
import Shared from "@/features/Shared.vue";
</script>

<template>
  <div class="shared-page">
    <Shared />
  </div>
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
.shared-page {
  display: flex;
  height: 100%;
  overflow: hidden;
}
</style>
